import { arrayToQueryString } from "../../js/utilities";
import { errorClasses, fieldTypes, helperClasses } from "./form";

/**
 * When we need a label, make sure we either get the label or the legend depending on type.
 * @returns {HTMLElement}
 */
const getFieldLabelElement = (field, type) => {
    if (type === "radio") {
        return field.getElementsByTagName("LEGEND")[0];
    }
    return field.getElementsByTagName("LABEL")[0];
};

/**
 * Validate our FormField so that we can get the right elements.
 * @param {HTMLElement} element
 * @param {String} type
 * @returns
 */
const validateHTML = (element, type) => {
    // Get the label Element before returning the model so we can get the content out of it.
    const labelElement = getFieldLabelElement(element, type);

    // Definition for our FormField type
    const validElements = {
        element,
        controls: Array.from(element.querySelectorAll(`.${fieldTypes[type].control}`)),
        controlType: type,
        helperText: element.querySelector(arrayToQueryString(helperClasses)),
        errorText: element.querySelector(arrayToQueryString(errorClasses)),
        label: {
            element: labelElement,
            content: labelElement && labelElement.textContent.trim(),
        },
    };

    return validElements;
};

/**
 * FormField class in a function.
 * @param {String} type
 * @param {HTMLElement} field
 * @returns {{
 *  element: HTMLElement,
 *  controls: Array<HTMLElement>,
 *  controlType: String,
 *  helperText: HTMLElement,
 *  errorText: HTMLElement,
 *  label:{
 *    element: HTMLElement,
 *    content: String
 *  }
 * }} public api object
 */
export const FormField = (field, props = {}) => {
    const validElements = validateHTML(field, props.type);

    const api = { ...validElements };

    return api;
};
